import { forwardRef, type HTMLAttributes, type ReactNode } from "react";
import { cn } from "~/lib/cn";

interface RevealProps extends HTMLAttributes<HTMLDivElement> {
  /** Open shows the content; closed collapses it to 0 and takes it out of the tab order. */
  open: boolean;
  children: ReactNode;
}

/**
 * T872 — the one public reveal (the founder, 2026-10-09: `desplegables compartidos para
 * fases, FAQ y Soporte`). The panel stays in the DOM (its text is what crawlers and the
 * FAQ search read) and opens by height: `.pub-reveal` animates `grid-template-rows`
 * 0fr → 1fr and opacity on `--pub-motion-reveal`, `.pub-reveal-inner` clips and eases its
 * bottom padding (`--pub-reveal-pad`, set by the consumer). Closed, `inert` keeps every
 * link inside out of the tab order and the accessibility tree — no `aria-hidden` and no
 * `tabIndex` bookkeeping on the children. Reduced motion dries it in the shared rule. The
 * toggle (a `<button aria-expanded aria-controls>`) belongs to the consumer, as does any
 * `role`/`aria-labelledby` the panel needs (a tabpanel, a region).
 */
export const Reveal = forwardRef<HTMLDivElement, RevealProps>(function Reveal({ open, className, children, ...rest }, ref) {
  return (
    <div ref={ref} className={cn("pub-reveal", className)} data-state={open ? "open" : "closed"} inert={open ? undefined : true} {...rest}>
      <div className="pub-reveal-inner">{children}</div>
    </div>
  );
});
